










































































import Vue from "vue";
import { LicenseData } from "@/models/license";
import validationMixin from "@/components/mixins/validationMixin";
import VaCard from "@/components/molecules/VaCard.vue";
import VaButton from "@/components/atoms/VaButton.vue";
import VaTextField from "@/components/atoms/VaTextField.vue";
import VaSwitch from "@/components/atoms/VaSwitch.vue";

export default Vue.extend({
  name: "NewLicenseForm",
  mixins: [validationMixin],
  components: {
    VaSwitch,
    VaTextField,
    VaButton,
    VaCard,
  },
  async beforeMount() {
    this.$store.commit("license/resetCurrentLicense");
  },
  data() {
    return {
      newLicense: {
        licenseKey: "",
        isRenewal: false,
      } as LicenseData,
      fileLicense: undefined,
    };
  },
  methods: {
    onDismiss(): void {
      this.$emit("onDismiss");
    },
    onFinish(): void {
      this.$emit("onFinish", this.newLicense.licenseKey);
    },
    async onUpload(): Promise<void> {
      await this.$store.dispatch("onprem/uploadLicense", this.fileLicense);
      this.onFinish();
      this.fileLicense = undefined;
    },

    async onSave(): Promise<void> {
      if (
        (
          this.$refs.newLicenseForm as Vue & { validate: () => boolean }
        ).validate()
      ) {
        this.onFinish();
        await this.$store.dispatch("license/addLicense", this.newLicense);
        this.newLicense = {
          licenseKey: "",
          isRenewal: false,
        };
      }
    },
  },
  computed: {
    isOnPrem(): boolean {
      return this.$store.getters["onprem/isOnPrem"];
    },
  },
});
